<template>
  <div data-testid="tardy-csv-upload-container">
    <CContainer>
      <CRow class="justify-content-center mt-4">
        <CCol md="12 text-center">
          <TardyCsvUploadTable data-testid="tardy-csv-upload-table">
          </TardyCsvUploadTable>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import TardyCsvUploadTable from "@/v3components/Datatables/TardyCsvUploadTable.vue"

export default {
  name: "TardyCsvUpload",
  components: { TardyCsvUploadTable }
}
</script>
